// src/api/sienaguardService.ts

import apiClient from './config';

export interface FoundDomain {
    id: string;
    run_id: string;
    domain: string;
}
  
  export interface ScriptRun {
    id: string;
    service_id: string;
    run_date: string;
    status: string;
    found_domains?: FoundDomain[];
  }

  export interface TyposquattingInfo {
    original_domain: string;
    fake_domain: string;
    type?: string;
    ipv4?: string;
    ns?: string;
    mx?: string;
  }
  
  export interface NamesTldInfo {
    domain: string;
    status: string;
    exp_date?: string;
  }
  
  export interface SienaguardService {
    id: string;
    user_id: string;
    domain: string;
    start_date: string;
    end_date: string;
    created_at: string;
    contact_email_count?: number;
  }
  
  
  export interface ContactMailResponse {
    id: number;
    service_id: string;
    email: string;
  }

  export interface IPInfo {
    domain: string;
    ip: string;
    country?: string;
    country_code?: string;
    city?: string;
    latitude?: number;
    longitude?: number;
    continent?: string;
    region?: string;
    postal?: string;
    asn?: number;
    isp?: string;
    org?: string;
    timezone?: string;
    created_at: string;
    updated_at?: string;
  }
  
  
  export interface SienaguardServiceDetail extends SienaguardService {
    runs?: ScriptRun[];
    contact_mails?: ContactMailResponse[];
    typosquatting_info?: TyposquattingInfo[];
    names_tld_info?: NamesTldInfo[];
    ip_info?: IPInfo[];
  }
  
export const addSienaguardService = async (domain: string, startDate: string, endDate: string) => {
  try {
    const response = await apiClient.post('/sienaguard', { domain, start_date: startDate, end_date: endDate });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getActiveServices = async (): Promise<SienaguardService[]> => {
  try {
    const response = await apiClient.get<SienaguardService[]>('/sienaguard');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getServiceDetail = async (serviceId: string): Promise<SienaguardServiceDetail> => {
  try {
    const response = await apiClient.get<SienaguardServiceDetail>(`/sienaguard/${serviceId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const getSienaguardTokens = async () => {
  try {
    const response = await apiClient.get('/sienaguard/tokens');  
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const addContactMail = async (serviceId: string, email: string): Promise<ContactMailResponse> => {
  try {
    const response = await apiClient.post('/sienaguard/contact-mail', { service_id: serviceId, email });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const removeContactMail = async (contactId: number): Promise<{ message: string }> => {
  try {
    const response = await apiClient.delete(`/sienaguard/contact-mail/${contactId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};